import React, { Component } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Snackbar, Alert, TablePagination } from '@mui/material';
import { promises } from 'dns';
import { Autocomplete, TextField } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Cancel, CheckCircle, Delete } from '@mui/icons-material';
import { green, red } from '@mui/material/colors';
import CheckIcon from '@mui/icons-material/Check';
import { getbroker } from '../../ApiSevices/UserMasterApis';
import { GridTable } from '../../Sidebar/SidebarStyles';
import EditIcon from "@mui/icons-material/Edit";
import { Chip } from "@mui/material";
import { getAllLobs, getAllChecklistTemplate, getSplitLobIdentifierConfig,getAllSplitLobIdentifierConfig, addQuestionConfigData, updateQuestionConfigData, activateOrDeactivateQConfig, getQuestionMaster, getChecklistLobCode, updateSplitLobIdentifierConfig, addSplitLobIdentifierConfig, updateSplitLobIdentifierConfigStatus, getChecklistLobDropdown, RemoveLobSplitConfigMapping, exportSplitLobIdentifierConfig } from '../../ApiSevices/QuestionConfigService';
import ConfirmationDialogComponent from "../../Common/ConfirmationDialogComponent"
import { decodeJwt } from '../ApiCommonService';

interface IProps {
    displaysidebar: boolean;
}

interface IState {
    QuestionMaster: any[],
    lobMaster: any[],
    brokerMaster: any[],
    questionConfigData: any[],
    loading: boolean,
    selectedSearchBrokerIds: number,
    selectedDialogBrokerIds: number[],
    selectedQuestionId: number,
    keyWord: string,
    ChecklistLobMaster: any[],
    selectedChecklistLobId: string,
    // selectedBrokerId: number,
    // selectedBrokerId: number,
    selectedTemplateId: number,
    selectedLobId: string,
    isDialogOpen: boolean,
    dialogData: any,
    confirmDialog: boolean,
    iconData: any,
    snackbarOpen: boolean,
    snackbarMessage: string,
    snackbarSeverity: 'success' | 'error';
    selectedChecklistSearchLob: string,
    questionCodeSearch: string,
    jobLobSearch: string,
    totalCount: number,
    rowsPerPage: number,
    page: number,
    ChecklistSearchMaster: any[],
    isEdit: boolean,
    editId: number,
    isBrokerFocused: boolean,
    brokerDropdownOpen: boolean,
    confirmationDialog: {
        isOpen: boolean,
        recordId: number,
        message: string,
        activate: boolean,
        isDelete?: boolean
    },
    tenantIds: number[],
    searchKeyword: string,
    allQuestionConfigData: any[],
}


const columns: GridColDef[] = [
    { field: 'Id', headerName: 'Id', width: 70 },
    { field: 'QuestionCode', headerName: 'Question Code', width: 200 },
    { field: 'Keyword', headerName: 'Key word', width: 250 },
    { field: 'ChecklistLobCode', headerName: 'Checklist LobCode', width: 200 },
    { field: 'JobLobCode', headerName: 'Job LobCode', width: 200 },
    { field: 'IsActive', headerName: 'Status', width: 100 },
    { field: 'Action', headerName: 'Action', width: 100 }
];

class LobSplitConfig extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            QuestionMaster: [],
            lobMaster: [],
            brokerMaster: [],
            questionConfigData: [],
            ChecklistLobMaster: [],
            selectedChecklistLobId: "",
            selectedSearchBrokerIds: 0,
            selectedDialogBrokerIds: [],
            selectedQuestionId: 0,
            selectedTemplateId: 0,
            selectedLobId: "",
            isDialogOpen: false,
            confirmDialog: false,
            iconData: null,
            snackbarOpen: false,
            snackbarSeverity: "success",
            keyWord: "",
            snackbarMessage: "",
            dialogData: {
                CoverageSpecificationMaster: '',
                ChecklistQuestions: '',
            },
            selectedChecklistSearchLob: "",
            questionCodeSearch: "",
            jobLobSearch: "",
            ChecklistSearchMaster: [],
            isEdit: false,
            editId: 0,
            isBrokerFocused: false,
            brokerDropdownOpen: false,
            page: 0,
            rowsPerPage: 100,
            totalCount: 0,
            confirmationDialog: {
                isOpen: false,
                recordId: 0,
                message: "",
                activate: false
            },
            tenantIds: [],
            searchKeyword: "",
            allQuestionConfigData: [],

        }
    }

    async componentDidMount(): Promise<void> {
        try {
            this.setState({ loading: true });
            const [lobResponse, questionMaster, brokerResponse, checklistLobCode, checklistSearchLob] = await Promise.all([
                getAllLobs(),
                getQuestionMaster(),
                getbroker(),
                getChecklistLobCode(),
                getChecklistLobDropdown()
            ]);

            let sortStaticArry = brokerResponse?.sort((a: any, b: any) => a?.vchBrokerName?.localeCompare(b?.vchBrokerName))
            let brokerMasterAltered = sortStaticArry?.map((e: any) => { return { label: e?.vchBrokerName, value: e?.Broker_ID } });
            brokerMasterAltered = brokerMasterAltered?.filter((f: any) => f?.value !== 0)

            let sortStemplateResArry = questionMaster?.sort((a: any, b: any) => a?.QuestionCode?.localeCompare(b?.QuestionCode))
            let templateMasterAltered = sortStemplateResArry?.map((e: any) => { return { label: e?.QuestionCode, value: e?.Id } });
            templateMasterAltered = templateMasterAltered?.filter((f: any) => f?.value !== 0)

            let sortChecklistResArry = checklistLobCode?.sort((a: any, b: any) => a?.Question?.localeCompare(b?.Question))
            let checklistMasterAltered = sortChecklistResArry?.map((e: any) => { return { label: e?.Question, value: e?.Id } });
            checklistMasterAltered = checklistMasterAltered?.filter((f: any) => f?.value !== 0)

            let lobMasterAltered = lobResponse.map((e: any) => ({
                label: e.Actual_LOB_Master,
                value: e.ACTUAL_LOB_CODE
            }));
            lobMasterAltered = lobMasterAltered?.filter((f: any) => f?.value !== 0)

            const checklistSearchMaster = checklistSearchLob.map((e: any) => ({
                label: e.ChecklistLobCode,
                value: e.ChecklistLobCode
            }));

            this.setState({
                lobMaster: lobMasterAltered,
                QuestionMaster: templateMasterAltered,
                brokerMaster: brokerMasterAltered,
                ChecklistLobMaster: checklistMasterAltered,
                ChecklistSearchMaster: checklistSearchMaster
            });
        } catch (error) {
            console.log(error);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    async getQuestionConfig(): Promise<void> {
        this.setState({ loading: true });
        try {
            const response = await getSplitLobIdentifierConfig(
                this.state.selectedSearchBrokerIds,
                this.state.selectedChecklistSearchLob,
                this.state.questionCodeSearch,
                this.state.jobLobSearch,
                this.state.page,
                this.state.rowsPerPage
            );
            const allData = await getAllSplitLobIdentifierConfig(
                [this.state.selectedSearchBrokerIds],
                this.state.selectedChecklistSearchLob,
                this.state.questionCodeSearch,
                this.state.jobLobSearch
            );

            const allQuestionConfigData = allData.map((e: any) => {
                const cfg = e.SplitLobIdentifierConfig;

                return {
                    ...cfg,
                    QuestionCode: e.QuestionCode
                };
            });
            const data = response.data.map((e: any) => {
                const SplitLobIdentifierConfig = e.SplitLobIdentifierConfig;
                const QuestionCode = e.QuestionCode;
                return { ...SplitLobIdentifierConfig, "QuestionCode": QuestionCode }
            });
            const { pagination, tenantIds } = response;

            this.setState({questionConfigData: data,allQuestionConfigData,totalCount: pagination?.totalRecords || 0,tenantIds: tenantIds || []});
        } catch (error) {
            this.setState({ questionConfigData: [] });
        }
        finally {
            this.setState({ loading: false });
        }
    }

    handleDialogOpen = () => {
        this.setState({
            isDialogOpen: true,
            selectedDialogBrokerIds: this.state.tenantIds,
            selectedChecklistLobId: this.state.selectedChecklistSearchLob,
            selectedQuestionId:
                this.state.QuestionMaster.find(
                    x => x.label === this.state.questionCodeSearch
                )?.value || 0,
            selectedLobId: this.state.jobLobSearch
        });
    };

    handleDialogClose = () => {
        this.setState({
            isDialogOpen: false,
            selectedDialogBrokerIds: [],
            isEdit: false,
            editId: 0,
            selectedQuestionId: 0,
            selectedChecklistLobId: "",
            selectedLobId: "",
            keyWord: "",

            dialogData: {
                CoverageSpecificationMaster: "",
                ChecklistQuestions: ""
            }
        });
    };

    handleDialogConfirm = () => {
        const { dialogData } = this.state;
        console.log('Dialog Confirmed with Data:', dialogData);

        this.addNewQuestionConfig(dialogData);
        this.handleDialogClose();
    };
    
    handleExport = async () => {
    try {
        this.setState({ loading: true });

        const response = await exportSplitLobIdentifierConfig(
            [this.state.selectedSearchBrokerIds],
            this.state.selectedChecklistSearchLob,
            this.state.questionCodeSearch,
            this.state.jobLobSearch
        );

        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "LobSplitConfiguration.xlsx";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error(error);
    } finally {
        this.setState({ loading: false });
    }
};

    updateQuestionConfigById = async () => {
        this.setState({ loading: true });
        try {
            const {
                editId,
                selectedQuestionId,
                selectedChecklistLobId,
                selectedDialogBrokerIds,
                selectedLobId,
                keyWord
            } = this.state;

            this.setState({ loading: true });

            const body = [
                {
                    Id: editId,
                    QuestionMasterId: selectedQuestionId,
                    ChecklistLobCode: selectedChecklistLobId,
                    BrokerIds: selectedDialogBrokerIds.join(","),
                    JobLobCode: selectedLobId,
                    Keyword: keyWord
                }
            ];

            await updateSplitLobIdentifierConfig(body);

            this.setState({
                snackbarMessage: "Updated Successfully",
                snackbarOpen: true,
                snackbarSeverity: "success"
            });

            this.handleDialogClose();
            this.getQuestionConfig();

        } catch (error) {
            console.log(error);

            this.setState({
                snackbarMessage: "Something went wrong",
                snackbarOpen: true,
                snackbarSeverity: "error"
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    };

    handleInputChange = (field: string, value: string) => {
        this.setState((prevState) => ({
            dialogData: {
                ...prevState.dialogData,
                [field]: value,
            },
        }));
    };

    handleEdit = (row: any) => {

        this.setState({
            isDialogOpen: true,
            isEdit: true,
            editId: row.Id,

            selectedQuestionId: row.QuestionMasterId,
            selectedChecklistLobId: row.ChecklistLobCode,
            selectedLobId: row.JobLobCode,
            keyWord: row.Keyword,

            selectedDialogBrokerIds:
                row.BrokerIds
                    ? row.BrokerIds
                        .split(",")
                        .map((x: string) => Number(x))
                    : []
        });
    };

    addNewQuestionConfig = async (data: { CoverageSpecificationMaster: string; ChecklistQuestions: string }) => {
        try {
            const { selectedLobId, selectedTemplateId, selectedDialogBrokerIds, selectedQuestionId, selectedChecklistLobId, keyWord } = this.state;
            this.setState({ loading: true });
            // const body = {
            //     "brokerId": selectedBrokerId,
            //     "templateId": selectedTemplateId,
            //     "lobId": selectedLobId,
            //     "coverageSpecificationMaster": data.CoverageSpecificationMaster,
            //     "checklistQuestion": data.ChecklistQuestions
            // }

            const body = {
                "Id": 0,
                "QuestionMasterId": selectedQuestionId,
                "ChecklistLobCode": selectedChecklistLobId,
                BrokerIds: selectedDialogBrokerIds.join(","),
                "IsActive": true,
                "IsDeleted": false,
                "JobLobCode": selectedLobId,
                "IsGlobal": true,
                "Keyword": keyWord,
                "CreatedOn": new Date().toISOString(),
                "UpdatedOn": new Date().toISOString(),
                "CreatedBy": 1,
                "UpdatedBy": 1
            }
            await addSplitLobIdentifierConfig(body);
            this.getQuestionConfig();
            this.setState({
                snackbarMessage: "Added Successfully",
                snackbarOpen: true,
                snackbarSeverity: "success"
            });
        } catch (error) {
            console.log(error);
            this.setState({
                snackbarMessage: "something went wrong",
                snackbarOpen: true,
                snackbarSeverity: "error"
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    };

    onUpdateClick = async () => {
        try {
            this.setState({ loading: true });
            const { questionConfigData } = this.state;
            const selectedRows = questionConfigData.filter(e => e.isSelected);

            const requiredKeys = ['Id', 'Keyword'];

            // Collect IDs of rows with empty or missing values
            const invalidRows = selectedRows.filter(item =>
                requiredKeys.some(key => !item[key] || item[key].toString().trim() === '')
            );

            if (invalidRows.length > 0) {
                invalidRows.forEach(row => console.log(row.id));
                this.setState({
                    snackbarMessage: "Some records are not filled for these Ids " + invalidRows.map(e => e.Id).toString(),
                    snackbarOpen: true,
                    snackbarSeverity: "error"
                });
                return; // Stop further execution
            }

            const body = selectedRows.map((e: any) => ({
                "Id": e.Id,
                "Keyword": e?.Keyword,
            }));
            if (body.length > 0) {
                await updateSplitLobIdentifierConfig(body);
                this.setState({
                    snackbarMessage: "Updated Successfully",
                    snackbarOpen: true,
                    snackbarSeverity: "success"
                });
            }
            this.getQuestionConfig();
        } catch (error) {
            console.log(error);
            this.setState({
                snackbarMessage: "something went wrong",
                snackbarOpen: true,
                snackbarSeverity: "error"
            });
        } finally {
            this.setState({ loading: false });
        }
    }

    handleCloseConfirmDialog = () => {
        this.setState({ confirmDialog: false });
    };

    handleActivate = async (row: any) => {
        try {
            this.setState({ loading: true });
            const body = {
                "ids": [
                    row.Id
                ],
                "status": !row.IsActive
            }
            await updateSplitLobIdentifierConfigStatus(row.Id, !row.IsActive);
            this.setState({
                snackbarMessage: (row.IsActive ? "Deactivated" : "Activated") + " successfully.",
                snackbarOpen: true,
                snackbarSeverity: "success",
            });
            this.getQuestionConfig();
        } catch (error) {
            console.log(error);
            this.setState({
                snackbarMessage: "something went wrong",
                snackbarOpen: true,
                snackbarSeverity: "error",
            });
            this.handleCloseConfirmDialog();
        } finally {
            this.setState({
                loading: false,
                confirmDialog: false
            });
        }
    }
    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    }

handlePageChange = (event: any, newPage: number) => {
    this.setState({ page: newPage });

    if (this.state.searchKeyword.trim() === "") {
        this.getQuestionConfig();
    }
};

    handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
        rowsPerPage: parseInt(event.target.value, 100),
        page: 0
    });

    if (this.state.searchKeyword.trim() === "") {
        this.getQuestionConfig();
    }
};

    onConfirmationDialog = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            if (this.state.confirmationDialog.isDelete) {
                await RemoveLobSplitConfigMapping(this.state.confirmationDialog.recordId);
            }

            await this.getQuestionConfig();
            this.setState({
                confirmationDialog: {
                    isOpen: false,
                    recordId: 0,
                    message: "",
                    activate: false,
                    isDelete: false
                }
            });
        } catch (e) {
            console.error(e);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const {
            loading, QuestionMaster, lobMaster, brokerMaster, selectedSearchBrokerIds, selectedDialogBrokerIds, selectedQuestionId, keyWord, selectedChecklistLobId,
            selectedLobId, questionConfigData, isDialogOpen, confirmDialog, iconData, snackbarMessage, snackbarOpen, snackbarSeverity, ChecklistSearchMaster,
            selectedChecklistSearchLob, questionCodeSearch, jobLobSearch, isEdit, totalCount, rowsPerPage, page, confirmationDialog
        } = this.state;
        const isConfirmEnabled = selectedQuestionId > 0 && selectedChecklistLobId.length > 0 &&
            selectedLobId.length > 0 && keyWord.trim().length > 0 && selectedDialogBrokerIds.length > 0;
        const token = sessionStorage.getItem('token');
        const decodedToken = decodeJwt(token);
        const userName = decodedToken?.userName || decodedToken?.Email;
        const showDelete = userName === "ramu_s@exdioninsurance.com" || userName === "Sanjay_joyit@exdioninsurance.com";        const isSearching = this.state.searchKeyword.trim().length > 0;

        const filteredQuestionConfigData = isSearching
            ? this.state.allQuestionConfigData.filter((row: any) =>
                row.Keyword?.toLowerCase().includes(
                    this.state.searchKeyword.toLowerCase()
                )
            ): this.state.allQuestionConfigData;
                
        const pagedQuestionConfigData = filteredQuestionConfigData.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
        );

        return (
            <div style={{ fontSize: "12px" }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable sx={{ height: '90vh' }} displaysidebar={this?.props?.displaysidebar}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "16px",
                            gap: "20px"
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: "bold",
                                fontSize: "12px",
                                whiteSpace: "nowrap"
                            }}
                        >
                            LobSplit Configuration
                        </Typography>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px"
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    fontWeight: 500
                                                    
                                }}
                            >
                                Find Keyword
                            </Typography>

                            <TextField
                        size="medium"
                        placeholder="Search Keyword..."
                        value={this.state.searchKeyword}
                        onChange={(e) =>
                            this.setState({
                                searchKeyword: e.target.value,
                                page: 0
                            })
                        }
                        InputProps={{
                            style: {
                                height: 25,
                                fontSize: "11px"
                            }
                        }}
                        sx={{
                            width: 220,
                            "& .MuiInputBase-input::placeholder": {
                                color: "#BDBDBD", // Gray placeholder
                                opacity: 1,
                                fontSize: "10px"
                            }
                        }}
                    />
                        </div>
                    </div>
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%"
                    }}>
                        {/* Broker id selection */}
                        {/* Broker */}
                        <div style={{ flex: "1 1 220px" }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    fontWeight: 500
                                }}
                            >
                                Select Broker
                            </Typography>

                            <Autocomplete
                                options={brokerMaster}
                                value={brokerMaster.find(x => x.value === selectedSearchBrokerIds) || null}
                                getOptionLabel={(option) => option.label}
                                onChange={(e, v) => {
                                    this.setState({
                                        selectedSearchBrokerIds: v?.value || 0,
                                        tenantIds: v ? this.state.tenantIds : []
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Checklist Lob..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                slotProps={{
                                    listbox: {
                                        sx: {
                                            "& .MuiAutocomplete-option": {
                                                fontSize: "11px",
                                                fontFamily: "inherit",
                                                minHeight: "28px",
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>

                        {/* Checklist Lob */}
                        <div style={{ flex: "1 1 220px" }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    fontWeight: 500
                                }}
                            >
                                Checklist Lob
                            </Typography>

                            <Autocomplete
                                options={ChecklistSearchMaster}
                                value={ChecklistSearchMaster.find(x => x.value === selectedChecklistSearchLob) || null}
                                getOptionLabel={(option) => option.label}
                                onChange={(e, v) => {
                                    this.setState({
                                        selectedChecklistSearchLob: v?.value || ""
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Checklist Lob..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                slotProps={{
                                    listbox: {
                                        sx: {
                                            "& .MuiAutocomplete-option": {
                                                fontSize: "11px",
                                                fontFamily: "inherit",
                                                minHeight: "28px",
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>

                        {/* Question Code */}
                        <div style={{ flex: "1 1 220px" }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    fontWeight: 500
                                }}
                            >
                                Question Code
                            </Typography>

                            <Autocomplete
                                options={QuestionMaster}
                                value={
                                    QuestionMaster.find(x => x.label === questionCodeSearch) || null
                                }
                                getOptionLabel={(option) => option.label}
                                onChange={(e, value) =>
                                    this.setState({
                                        questionCodeSearch: value?.label || ""
                                    })
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Question Code..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                slotProps={{
                                    listbox: {
                                        sx: {
                                            "& .MuiAutocomplete-option": {
                                                fontSize: "11px",
                                                fontFamily: "inherit",
                                                minHeight: "28px",
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>

                        {/* Job Lob */}
                        <div style={{ flex: "1 1 220px" }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    fontWeight: 500
                                }}
                            >
                                Job Lob
                            </Typography>
                            <Autocomplete
                                options={lobMaster}
                                value={
                                    lobMaster.find(x => x.value === jobLobSearch) || null
                                }
                                getOptionLabel={(option) => option.label}
                                onChange={(e, value) =>
                                    this.setState({
                                        jobLobSearch: value?.value || ""
                                    })
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Job Lob..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: {
                                                height: 25,
                                                fontSize: "11px"
                                            }
                                        }}
                                    />
                                )}
                                slotProps={{
                                    listbox: {
                                        sx: {
                                            "& .MuiAutocomplete-option": {
                                                fontSize: "11px",
                                                fontFamily: "inherit"
                                            }
                                        }
                                    }
                                }}
                            />
                        </div>

                        {/* Search
                        <div style={{marginTop:20}}>

                        <button
                            disabled={
                            !(selectedBrokerId && selectedChecklistSearchLob)
                        }

                        style={{
                            opacity: (selectedBrokerId && selectedChecklistSearchLob) ? 1 : 0.5
                        }}
                            onClick={()=>this.getQuestionConfig()}
                        >
                        Search
                        </button>

                        </div> */}

                        {/* Search button */}
                        <div
                            style={{
                                flex: "1 1 150px",
                                minWidth: "150px",
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                paddingTop: "10px"
                            }}
                        >
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor:
                                        selectedSearchBrokerIds && selectedChecklistSearchLob
                                            ? "pointer"
                                            : "not-allowed",
                                    fontSize: "12px",
                                    marginTop: "15px",
                                    opacity:
                                        selectedSearchBrokerIds && selectedChecklistSearchLob
                                            ? 1
                                            : 0.5,
                                    pointerEvents:
                                        selectedSearchBrokerIds && selectedChecklistSearchLob
                                            ? "auto"
                                            : "none"
                                }}
                                onClick={() => {
                                    this.getQuestionConfig();
                                }}
                                disabled={!(selectedSearchBrokerIds && selectedChecklistSearchLob)}
                            >
                                Search
                            </button>
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor:
                                        selectedSearchBrokerIds && selectedChecklistSearchLob
                                            ? "pointer"
                                            : "not-allowed",
                                    fontSize: "12px",
                                    marginTop: "15px",
                                    marginLeft: "8px",
                                    opacity:
                                        selectedSearchBrokerIds && selectedChecklistSearchLob
                                            ? 1
                                            : 0.5,
                                    pointerEvents:
                                        selectedSearchBrokerIds && selectedChecklistSearchLob
                                            ? "auto"
                                            : "none"
                                }}
                                disabled={!(selectedSearchBrokerIds && selectedChecklistSearchLob)}
                                onClick={this.handleExport}
                            >
                                Export
                            </button>
                        </div>
                    </div>
                    {/* Question Config List in Table */}
                    <br />
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: "wrap",
                                gap: "20px",
                                alignItems: "center",
                                justifyContent: "flex-end",
                            }}
                        >
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                }}
                                onClick={this.handleDialogOpen}
                            >
                                Add
                            </button>
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                }}
                                onClick={() => {
                                    this.setState({ page: 0, rowsPerPage: 100 }, () =>
                                        this.getQuestionConfig())
                                }}
                            >Refresh</button>
                        </div>
                        <br />
                        <div>

                            <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
                                <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
                                    <TableContainer sx={{ minWidth: 'max-content' }}> {/* Enable scrolling */}
                                        <Table stickyHeader sx={{ height: '50px' }} size="small">
                                            {/* Table Header */}
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.field}
                                                            sx={{
                                                                fontSize: '12px',
                                                                fontWeight: 'bold',
                                                                whiteSpace: 'nowrap',
                                                                backgroundColor: '#f5f5f5',
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 1,
                                                                width: column.width,
                                                                minWidth: column.width,
                                                                maxWidth: column.width,
                                                            }}
                                                        >
                                                            {column.headerName}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                        </Table>
                                        {/* Table Body */}
                                        <Box sx={{ maxHeight: 310, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                            <Table size="small">
                                                <TableBody>
                                                    {filteredQuestionConfigData.length === 0 ? (
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={columns.length}
                                                                align="center"
                                                                sx={{
                                                                    fontSize: "14px",
                                                                    fontWeight: 500,
                                                                    color: "gray",
                                                                    padding: "20px",
                                                                    borderBottom: "none",
                                                                }}
                                                            >
                                                                No records to display
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        pagedQuestionConfigData.map((row) => (
                                                            <TableRow key={row.Id}>
                                                                {columns.map((column) => (
                                                                    <TableCell
                                                                        key={column.field}
                                                                        sx={{
                                                                            fontSize: "10px",
                                                                            whiteSpace: "normal",
                                                                            wordWrap: "break-word",
                                                                            lineHeight: "1.5",
                                                                            width: column.width,
                                                                            minWidth: column.width,
                                                                            maxWidth: column.width,
                                                                        }}
                                                                    >
                                                                        {row.isSelected &&
                                                                            column.field.toLowerCase() !== "id" &&
                                                                            column.field !== "QuestionCode" &&
                                                                            column.field !== "ChecklistLobCode" &&
                                                                            column.field !== "JobLobCode" &&
                                                                            column.field.toLowerCase() !== "isactive" &&
                                                                            column.field.toLowerCase() !== "action" ? (
                                                                            <input
                                                                                type="text"
                                                                                value={row[column.field] || ""}
                                                                                onChange={(event) => {
                                                                                    const newValue = event.target.value;
                                                                                    this.setState((prevState) => ({
                                                                                        allQuestionConfigData:
                                                                                            prevState.allQuestionConfigData.map((r) =>
                                                                                                r.Id === row.Id
                                                                                                    ? { ...r, [column.field]: newValue }
                                                                                                    : r
                                                                                            ),
                                                                                    }));
                                                                                }}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    fontSize: "10px",
                                                                                    padding: "4px",
                                                                                    boxSizing: "border-box",
                                                                                    border: "1px solid black",
                                                                                }}
                                                                            />
                                                                        ) : column.field === "IsActive" ? (
                                                                            row[column.field] ? "Active" : "Inactive"
                                                                        ) : column.field === "Action" ? (
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                                                <EditIcon
                                                                                    sx={{ cursor: "pointer" }}
                                                                                    onClick={() => this.handleEdit(row)}
                                                                                />
                                                                                {row.IsActive ? (
                                                                                    <Cancel
                                                                                        sx={{ cursor: "pointer" }}
                                                                                        onClick={() =>
                                                                                            this.setState({
                                                                                                iconData: row,
                                                                                                confirmDialog: true,
                                                                                            })
                                                                                        }
                                                                                        style={{ color: red[500] }}
                                                                                    />
                                                                                ) : (
                                                                                    <CheckIcon
                                                                                        sx={{ cursor: "pointer" }}
                                                                                        onClick={() =>
                                                                                            this.setState({
                                                                                                iconData: row,
                                                                                                confirmDialog: true,
                                                                                            })
                                                                                        }
                                                                                        style={{ color: green[500] }}
                                                                                    />
                                                                                )}
                                                                                {showDelete && (<Delete sx={{ cursor: "pointer" }} onClick={() => {
                                                                                    this.setState({
                                                                                        confirmationDialog: {
                                                                                            isOpen: true,
                                                                                            recordId: row?.Id,
                                                                                            message: `Are you Sure you want to delete this record of Id: ${row?.Id}?`,
                                                                                            activate: false,
                                                                                            isDelete: true
                                                                                        }
                                                                                    });
                                                                                }} />
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            row[column.field]
                                                                        )}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        ))
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </TableContainer>
                                </Box>
                                <TablePagination
                                    component="div"
                                    count={filteredQuestionConfigData.length}
                                    page={page}
                                    onPageChange={this.handlePageChange}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={this.handleRowsPerPageChange}
                                    rowsPerPageOptions={[10, 25, 50, 100, 200]}
                                />
                            </Paper>

                        </div>
                    </div>
                    {/* Dialog */}
                    <Dialog open={isDialogOpen} onClose={this.handleDialogClose} fullWidth maxWidth="md">
                        <DialogTitle>
                            {isEdit ? "Edit Question Config" : "Add New Question Config"}
                        </DialogTitle>
                        <DialogContent>
                            <Typography
                                variant="body2"
                                sx={{ mb: 0.5, mt: 2, fontWeight: 500 }}
                            >
                                Broker
                            </Typography>

                            <Autocomplete
                                multiple
                                disableClearable
                                options={brokerMaster}
                                value={brokerMaster.filter(x =>
                                    selectedDialogBrokerIds.includes(x.value)
                                )}
                                getOptionLabel={(option) => option.label}
                                onChange={(e, values) => {
                                    this.setState({
                                        selectedDialogBrokerIds: values.map(x => x.value)
                                    })
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Broker..."
                                        size="small"
                                    />
                                )}
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    mt: 2,
                                    fontWeight: 500
                                }}
                            >
                                Question Code
                            </Typography>
                            <Autocomplete
                                options={QuestionMaster}
                                getOptionLabel={(option) => option?.label || ''}
                                value={QuestionMaster.find((e: any) => e.value === selectedQuestionId) || null}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedQuestionId: newValue?.value || 0 });
                                }}
                                disabled={isEdit}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Question Code..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    mt: 2,
                                    fontWeight: 500
                                }}
                            >
                                Checklist Lob Code
                            </Typography>
                            <Autocomplete
                                options={ChecklistSearchMaster}
                                getOptionLabel={(option) => option?.label || ''}
                                value={ChecklistSearchMaster.find((e: any) => e.value === selectedChecklistLobId) || null}
                                onChange={(event, newValue) => {
                                    this.setState({ selectedChecklistLobId: newValue?.value || 0 });
                                }}
                                disabled={isEdit}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Checklist Lob Code..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    mt: 2,
                                    fontWeight: 500
                                }}
                            >
                                Job Lob Code
                            </Typography>
                            <Autocomplete
                                options={lobMaster}
                                getOptionLabel={(option) => option?.label || ''}
                                value={lobMaster.find((e: any) => e.value === selectedLobId) || null}
                                onChange={(event, newValue) => {
                                    this.setState({
                                        selectedLobId: newValue?.value || ""
                                    });
                                }}
                                disabled={isEdit}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Job Lob Code..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 0.5,
                                    mt: 2,
                                    fontWeight: 500
                                }}
                            >
                                Key Word
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                value={keyWord}
                                placeholder="Enter Key Word..."
                                onChange={(e) =>
                                    this.setState({ keyWord: e.target.value })
                                }
                                sx={{
                                    "& textarea": {
                                        resize: "vertical",   // or "both"
                                        overflow: "auto",
                                        fontSize: "13px",
                                    },
                                }}
                            />
                        </DialogContent>
                        <DialogActions
                            sx={{
                                px: 3,
                                py: 2,
                                justifyContent: "flex-end",
                                gap: 1,
                            }}
                        >
                            <Button
                                onClick={this.handleDialogClose}
                                sx={{
                                    color: "#1976d2",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    textTransform: "uppercase",
                                    minWidth: 90,
                                    "&:hover": {
                                        backgroundColor: "rgba(25,118,210,0.08)",
                                    },
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                onClick={() => {
                                    if (isEdit) {
                                        this.updateQuestionConfigById();
                                    } else {
                                        this.handleDialogConfirm();
                                    }
                                }}
                                disabled={!isConfirmEnabled}
                                sx={{
                                    minWidth: 120,
                                    height: 40,
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    textTransform: "uppercase",
                                    borderRadius: "4px",
                                    boxShadow: "0px 3px 5px rgba(0,0,0,0.25)",
                                    "&:hover": {
                                        backgroundColor: "#1565c0",
                                        boxShadow: "0px 5px 10px rgba(0,0,0,0.3)",
                                    },
                                    "&.Mui-disabled": {
                                        backgroundColor: "#c7c7c7",
                                        color: "#ffffff",
                                    },
                                }}
                            >
                                {isEdit ? "Update" : "Submit"}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    < Dialog open={confirmDialog} onClose={this.handleCloseConfirmDialog} >
                        <DialogContent sx={{
                            padding: '0px 20px',
                            paddingTop: '25px',
                            paddingBottom: '35px',
                            textAlign: 'center',
                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                {iconData ? (
                                    <Box
                                        sx={{
                                            backgroundColor: '#FEE2E2',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Cancel sx={{ color: '#B91C1C', fontSize: 30 }} />
                                    </Box>
                                ) : (
                                    <Box
                                        sx={{
                                            backgroundColor: '#ECFDF5',
                                            borderRadius: '50%',
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <CheckCircle sx={{ color: '#6fd96f', fontSize: 30 }} />
                                    </Box>
                                )}
                            </Box>
                            {/* <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>
                                  Activate/Deactivate User
                                </DialogTitle> */}
                            <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.7)' }}>
                                Are you sure want to {iconData?.IsActive ? 'Deactivate' : 'Activate'} the question.
                            </DialogContentText>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        px: 4,
                                        borderRadius: '6px',
                                    }}
                                    onClick={() => this.handleActivate(iconData)}
                                >
                                    Yes
                                </Button>
                                <Button
                                    onClick={this.handleCloseConfirmDialog}
                                    sx={{
                                        color: '#007bff',
                                        borderColor: '#007bff',
                                        border: '0.5px solid #53494987',
                                        px: 4,
                                        borderRadius: '6px',
                                        '&:hover': {
                                            borderColor: '#0056b3',
                                            color: '#0056b3',
                                        },
                                    }}
                                >
                                    No
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog >

                    <ConfirmationDialogComponent open={confirmationDialog.isOpen} message={confirmationDialog.message} onConfirm={() => { this.onConfirmationDialog() }} onClose={() => {
                        this.setState({
                            confirmationDialog: {
                                isOpen: false,
                                recordId: 0,
                                message: "",
                                activate: false,
                                isDelete: false
                            }
                        });
                    }} />
                </GridTable>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert
                        onClose={this.handleCloseSnackbar}
                        severity={snackbarSeverity}
                        sx={{ width: '100%' }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
}

export default LobSplitConfig;
